import React, { useEffect, useState, useContext } from "react";
import Im from "immutable";
import { BSCard, postFetch, prefixProtocol } from "./utils";
import { AuthContext } from "./context";

import LoginForm from "./login";

function ActivationConfirmed() {
  return (
    <div>
      <p>Your email address is confirmed and account activated.</p>
      <p>
        Please log in with the username or email and password you used to
        register.
      </p>
      <br />
      <LoginForm hideCreateAccount />
    </div>
  );
}

function ActivationFailed({ errors }) {
  errors = errors?.get("non_field_errors");
  console.log("Got activation errors", errors, Im.isList(errors));
  // Iterate through erros to find any already_activated ones
  let extra = null;
  if (Im.isList(errors)) {
    errors.map((error) => {
      if (typeof error === "string" && error.includes("already_activated")) {
        extra = (
          <div>
            <p>
              Your account has already been activated. Please try logging in.
            </p>
            <br />
            <LoginForm hideCreateAccount />
          </div>
        );
      }
      return null;
    });
  }
  //
  return (
    <div>
      <p>There was an error with your account activation.</p>
      {extra || <div className="alert alert-danger">{errors}</div>}
    </div>
  );
}

function PleaseWait() {
  return (
    <div>
      <p>Please wait...</p>
    </div>
  );
}

const CONTENTS = {
  failed: {
    title: "Activation failed",
    Component: ActivationFailed,
  },
  confirmed: {
    title: "Email confirmed. You may log in.",
    Component: ActivationConfirmed,
  },
};

const getContents = (status) => {
  return (
    CONTENTS[status] || {
      title: "Waiting for confirmation",
      Component: PleaseWait,
    }
  );
};

export default function ActivationPage(props) {
  const { host } = useContext(AuthContext);
  const { activationKey: activation_key } = props.match.params;
  const [status, setStatus] = useState("");
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    postFetch({
      url: `${prefixProtocol(host)}/auth-rest/register/activate/`,
      data: { activation_key },
      method: "PUT",
      onSuccess: () => setStatus("confirmed"),
      onFailure: (data) => {
        setStatus("failed");
        setErrors(Im.fromJS(data));
      },
    });
  }, [activation_key, host]);

  const { title, Component } = getContents(status);

  return (
    <div className="container" style={{ marginTop: "24px" }}>
      <div className="col-sm-8 offset-sm-2">
        <BSCard title={title} body={<Component {...props} errors={errors} />} />
      </div>
    </div>
  );
}
